/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type HumanityMedianGasFeeRequest = {
    period?: HumanityMedianGasFeeRequest.period;
};

export namespace HumanityMedianGasFeeRequest {

    export enum period {
        D7 = 'D7',
        D30 = 'D30',
        D90 = 'D90',
        ALL = 'ALL',
    }


}

